import { pickBy } from 'lodash';
import { generateKeys, generateLocalization } from '../utils';
import { countries } from './countries';
import { corporateFields } from './corporateAccount';
export const fundingCategories = generateLocalization('fundingCategories', generateKeys({
    card: {
        value: 'card',
        label: 'Credit/Debit Card',
        localization: { id: '', defaultMessage: '' },
    },
    bankWire: {
        value: 'bankWire',
        label: 'Bank Wire',
        localization: { id: '', defaultMessage: '' },
    },
    onlineBanking: {
        value: 'onlineBanking',
        label: 'Online Banking',
        localization: { id: '', defaultMessage: '' },
    },
    eWallet: {
        value: 'eWallet',
        label: 'E-Wallet',
        localization: { id: '', defaultMessage: '' },
    },
    crypto: {
        value: 'crypto',
        label: 'Crypto',
        localization: { id: '', defaultMessage: '' },
    },
    onlineDeposit: {
        value: 'onlineDeposit',
        label: 'Online Deposit',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const documentRejectionReasons = generateLocalization('documentRejectionReasons', generateKeys({
    duplicateDocument: {
        label: 'Duplicate document',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    failedVerification: {
        label: 'Failed verification process (Unable to accept)',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    notAcceptableDocType: {
        label: 'Not acceptable document type',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
    expiredDoc: {
        label: 'Expired/ outdated document',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    unclearDoc: {
        label: 'Unclear document',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    notAcceptableInfo: {
        label: 'Not acceptable as necessary information are covered',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
    notFullPageOfDoc: {
        label: 'Not full page of the document',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    nameMismatch: {
        label: 'Name on document does not match profile name',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    addressMismatch: {
        label: 'Address on document does not match address details',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    sensibleInfoVisible: {
        label: 'Sensitive information visible',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    relevantDocument: {
        label: 'Relevant Document',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const documentStatuses = generateLocalization('documentStatuses', generateKeys({
    notProcessed: {
        value: 'none',
        label: 'Not Processed',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    autoVerificationSent: {
        value: 'auto_verification_sent',
        label: 'Sent For Auto Verification',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    autoVerificationReceived: {
        value: 'auto_verification_received',
        label: 'Auto Verification Result Received',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    autoVerificationRejected: {
        value: 'auto_verification_rejected',
        label: 'Auto Verification Rejected',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    autoVerificationAccepted: {
        value: 'auto_verification_accepted',
        label: 'Auto Verification Accepted',
        localization: { id: '', defaultMessage: '' },
    },
    autoVerificationError: {
        value: 'auto_verification_error',
        label: 'Auto Verification Failed',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    accepted: {
        value: 'accepted',
        label: 'Accepted',
        localization: { id: '', defaultMessage: '' },
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        localization: { id: '', defaultMessage: '' },
    },
    pending: {
        value: 'pending',
        label: 'Pending',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    pendingTranslation: {
        value: 'pending_translation',
        label: 'Pending Translation',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const documentComments = generateLocalization('documentComments', generateKeys({
    notOlder: {
        value: 'notOlder',
        label: 'Not older than 8 months',
        localization: { id: '', defaultMessage: '' },
    },
    lastStatements: {
        value: 'lastStatements',
        label: 'The Company\'s latest audited financial statements or the Company\'s latest management accounts or a Trial Balance signed by the company\'s accountants and director(s) or any other documentation which indicates the current financial situation of the Company (if available).',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const documentAlternativeComments = generateLocalization('documentAlternativeComments', generateKeys({
    passedOneYearCommentGSC: {
        value: 'passedOneYearComment',
        label: 'A Good standing certificate is required if the company has completed one year, from the date of incorporation.',
        localization: { id: '', defaultMessage: '' },
    },
    passedOneYearCommentFS: {
        value: 'passedOneYearCommentFS',
        label: 'A Financial statement is required if the company has completed one year, from the date of incorporation.',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const documentTypes = generateLocalization('documentTypes', generateKeys({
    idFront: {
        value: 'doc_id_front',
        label: 'ID (Front)',
        category: 'POI',
        subCategories: ['POI-F'],
        sideName: 'Front',
        doubleSided: true,
        groupName: 'id',
        autoVerifiable: true,
        localization: { id: '', defaultMessage: '' },
        beneficiaryDirector: true,
    },
    idBack: {
        value: 'doc_id_back',
        label: 'ID (Back)',
        category: 'POI',
        subCategories: ['POI-B'],
        sideName: 'Back',
        doubleSided: true,
        groupName: 'id',
        autoVerifiable: true,
        localization: { id: '', defaultMessage: '' },
        beneficiaryDirector: true,
    },
    idTranslation: {
        value: 'doc_id_translation',
        label: 'ID Translation',
        localization: { id: '', defaultMessage: '' },
    },
    proofOfAddressTranslation: {
        value: 'doc_por_translation',
        label: 'POR Translation',
        localization: { id: '', defaultMessage: '' },
    },
    bankStatement: {
        value: 'doc_bank_statement',
        label: 'Bank Statement',
        localization: { id: '', defaultMessage: '' },
    },
    address: {
        value: 'doc_address',
        label: 'Proof of Residence',
        disabled: true,
        localization: { id: '', defaultMessage: '' },
    },
    passport: {
        value: 'doc_passport',
        label: 'Passport',
        category: 'POI',
        subCategories: ['POI-F', 'POI-B'],
        autoVerifiable: true,
        localization: { id: '', defaultMessage: '' },
        beneficiaryDirector: true,
    },
    iBagreement: {
        value: 'doc_ib_agreement',
        label: 'IB Agreement',
        category: 'internal',
        subCategories: ['internal', 'internal'],
        localization: { id: '', defaultMessage: '' },
    },
    dueDiligence: {
        value: 'doc_due_diligence',
        label: 'Due Diligence',
        category: 'internal',
        subCategories: ['internal', 'internal'],
        localization: { id: '', defaultMessage: '' },
    },
    proofOfSignature: {
        value: 'doc_proof_of_signature',
        label: 'Proof of Signature',
        category: 'internal',
        subCategories: ['internal', 'internal'],
        localization: { id: '', defaultMessage: '' },
    },
    approvalRejectionForm: {
        value: 'doc_approval_rejection_form',
        label: 'Approval Rejection Form',
        category: 'internal',
        subCategories: ['internal', 'internal'],
        localization: { id: '', defaultMessage: '' },
    },
    specialPowerOfAttorney: {
        value: 'doc_special_power_of_attorney',
        label: 'Special power of attorney',
        category: 'internal',
        subCategories: ['internal', 'internal'],
        localization: { id: '', defaultMessage: '' },
    },
    limitedPowerOfAttorney: {
        value: 'doc_limited_power_of_attorney',
        label: 'Limited power of attorney',
        category: 'internal',
        subCategories: ['internal', 'internal'],
        localization: { id: '', defaultMessage: '' },
    },
    revocationOfPoaSpoa: {
        value: 'doc_revocation_of_poa_spoa',
        label: 'Revocation of Power of Attorney / Special Power of Attorney',
        category: 'internal',
        subCategories: ['internal', 'internal'],
        localization: { id: '', defaultMessage: '' },
    },
    thirdPartyAuthorizationLetter: {
        value: 'doc_third_party_authorization_letter',
        label: '3rd party authorization letter',
        category: 'internal',
        subCategories: ['internal', 'POF'],
        localization: { id: '', defaultMessage: '' },
    },
    thirdPartyIdPassport: {
        value: 'doc_third_party_id_passport',
        label: '3rd party ID/Passport',
        category: 'internal',
        subCategories: ['internal', 'POF'],
        localization: { id: '', defaultMessage: '' },
    },
    drivingLicenseFront: {
        value: 'doc_driving_license_front',
        label: 'Driving licence (Front)',
        category: 'POI',
        subCategories: ['POI-F'],
        sideName: 'Front',
        doubleSided: true,
        groupName: 'drivingLicense',
        autoVerifiable: true,
        localization: { id: '', defaultMessage: '' },
        beneficiaryDirector: true,
    },
    drivingLicenseBack: {
        value: 'doc_driving_license_back',
        label: 'Driving licence (Back)',
        category: 'POI',
        subCategories: ['POI-B'],
        sideName: 'Back',
        doubleSided: true,
        groupName: 'drivingLicense',
        autoVerifiable: true,
        localization: { id: '', defaultMessage: '' },
        beneficiaryDirector: true,
    },
    residencePermitVisa: {
        value: 'doc_residence_permit_visa',
        label: 'Residence permit/visa',
        category: 'internal',
        subCategories: ['internal', 'internal'],
        localization: { id: '', defaultMessage: '' },
    },
    utilityBill: {
        value: 'doc_utility_bill',
        label: 'Utility Bill',
        category: 'POR',
        subCategories: ['POR'],
        autoVerifiable: true,
        localization: { id: '', defaultMessage: '' },
        beneficiaryDirector: true,
    },
    proofOfResidence: {
        value: 'doc_por',
        label: 'Proof of Residence',
        category: 'POR',
        subCategories: ['POR'],
        autoVerifiable: true,
        localization: { id: '', defaultMessage: '' },
        beneficiaryDirector: true,
    },
    bankStatementPOR: {
        value: 'doc_bank_statement_por',
        label: 'Bank Statement',
        category: 'POR',
        subCategories: ['POR'],
        autoVerifiable: true,
        localization: { id: '', defaultMessage: '' },
        beneficiaryDirector: true,
    },
    hukouPOR: {
        value: 'hukou_por',
        label: 'Hukou Book (Front)',
        category: 'POR',
        subCategories: ['POR'],
        autoVerifiable: true,
        groupName: 'hukouBook',
        sideName: 'Front',
        doubleSided: true,
        localization: { id: '', defaultMessage: '' },
        applicableCountries: [countries.cn.value],
    },
    hukouPORBack: {
        value: 'hukou_por_back',
        label: 'Hukou Book (Back)',
        category: 'POR',
        subCategories: ['POR'],
        autoVerifiable: true,
        groupName: 'hukouBook',
        sideName: 'Back',
        doubleSided: true,
        localization: { id: '', defaultMessage: '' },
        applicableCountries: [countries.cn.value],
    },
    cardCopies: {
        value: 'doc_card_copies',
        label: 'Credit/Debit Card Copy (Front)',
        doubleSided: true,
        groupName: 'card',
        sideName: 'Front',
        category: 'POF',
        subCategories: ['POF-F', 'POF-B'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.card.value,
        ],
    },
    cardCopiesBack: {
        value: 'doc_card_copies_back',
        label: 'Credit/Debit Card Copy (Back)',
        doubleSided: true,
        groupName: 'card',
        sideName: 'Back',
        category: 'POF',
        subCategories: ['POF-F', 'POF-B'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.card.value,
        ],
    },
    cardStatement: {
        value: 'doc_card_statement',
        label: 'Card Statement',
        category: 'POF',
        subCategories: ['POF-F'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.card.value,
        ],
    },
    bankStatementPOF: {
        value: 'doc_bank_statement_pof',
        label: 'Bank Statement',
        category: 'POF',
        subCategories: ['POF-F', 'POF-B'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.card.value,
            fundingCategories.eWallet.value,
            fundingCategories.bankWire.value,
            fundingCategories.onlineBanking.value,
        ],
    },
    swiftCopyPaymentAdvice: {
        value: 'doc_swift_copy_payment_advice',
        label: 'Swift Copy/Payment Advice',
        category: 'POF',
        subCategories: ['POF-F', 'POF-B'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.card.value,
            fundingCategories.bankWire.value,
            fundingCategories.onlineBanking.value,
        ],
    },
    worldcheckResults: {
        value: 'doc_worldcheck_results',
        label: 'Worldcheck Results',
        category: 'internal',
        subCategories: ['internal'],
        localization: { id: '', defaultMessage: '' },
    },
    virtualCard: {
        value: 'virtual_card',
        label: 'Virtual card',
        category: 'POF',
        subCategories: ['POF-F', 'POF-B'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.card.value,
        ],
    },
    bankCard: {
        value: 'bank_card',
        label: 'Bank card',
        category: 'internal',
        subCategories: ['internal', 'POF'],
        localization: { id: '', defaultMessage: '' },
    },
    coinbasePop: {
        value: 'coinbase_pop',
        label: 'Coinbase POP',
        category: 'internal',
        subCategories: ['internal', 'POF'],
        localization: { id: '', defaultMessage: '' },
    },
    taxStatement: {
        value: 'tax_statement',
        label: 'Tax Statement',
        category: 'internal',
        subCategories: ['internal'],
        localization: { id: '', defaultMessage: '' },
    },
    payslip: {
        value: 'payslip',
        label: 'Payslip/Payroll',
        category: 'internal',
        subCategories: ['internal'],
        localization: { id: '', defaultMessage: '' },
    },
    jointAccountForm: {
        value: 'joint_account_form',
        label: 'Joint Account Form',
        category: 'internal',
        subCategories: ['internal'],
        localization: { id: '', defaultMessage: '' },
    },
    bankPaymentDetails: {
        value: 'bank_payment_details',
        label: 'Bank/Payment details',
        category: 'internal',
        subCategories: ['internal', 'POF'],
        localization: { id: '', defaultMessage: '' },
    },
    companiesRegistryExtract: {
        value: 'companies_registry_extract',
        label: 'Companies registry extract',
        category: 'internal',
        subCategories: ['internal'],
        localization: { id: '', defaultMessage: '' },
    },
    promotionalMaterial: {
        value: 'promotional_material',
        label: 'Promotional Material',
        category: 'partner',
        subCategories: ['partner', 'ib'],
        localization: { id: '', defaultMessage: '' },
    },
    businessLicense: {
        value: 'businessLicense',
        label: 'Business License',
        category: 'partner',
        subCategories: ['partner', 'ib'],
        localization: { id: '', defaultMessage: '' },
    },
    professionalApplication: {
        value: 'professionalApplication',
        label: 'Professional Application',
        category: 'internal',
        subCategories: ['internal'],
        localization: { id: '', defaultMessage: '' },
    },
    thirdPartyWc: {
        value: 'third_party_wc',
        label: '3rd Party WC',
        category: 'internal',
        subCategories: ['internal', 'POF'],
        localization: { id: '', defaultMessage: '' },
    },
    privateWallet: {
        value: 'private_wallet',
        label: 'Private Wallet',
        category: 'POF',
        subCategories: ['POF-F'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.crypto.value,
        ],
    },
    btcEthPop: {
        value: 'btc_eth_pop',
        label: 'BTC/ETH POP',
        category: 'POF',
        subCategories: ['POF-F'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.crypto.value,
        ],
    },
    other: {
        value: 'doc_other',
        label: 'Other',
        category: 'internal',
        subCategories: ['internal'],
        localization: { id: '', defaultMessage: '' },
    },
    otherPOF: {
        value: 'doc_other_pof',
        label: 'Other',
        category: 'POF',
        subCategories: ['POF-F'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.card.value,
            fundingCategories.bankWire.value,
            fundingCategories.crypto.value,
            fundingCategories.eWallet.value,
            fundingCategories.onlineBanking.value,
            fundingCategories.onlineDeposit.value,
        ],
    },
    residencePermit: {
        value: 'residence_permit',
        label: 'Residence Permit (Front)',
        category: 'POI',
        subCategories: ['POI-F'],
        sideName: 'Front',
        doubleSided: true,
        groupName: 'residencePermit',
        localization: { id: '', defaultMessage: '' },
        applicableCountries: [countries.at.value, countries.bg.value, countries.hr.value, countries.cz.value, countries.dk.value, countries.ee.value,
            countries.fi.value, countries.fr.value, countries.de.value, countries.gr.value, countries.hu.value, countries.is.value, countries.ie.value,
            countries.it.value, countries.lv.value, countries.li.value, countries.lt.value, countries.lu.value, countries.mt.value, countries.no.value,
            countries.pl.value, countries.pt.value, countries.ro.value, countries.sk.value, countries.si.value, countries.es.value, countries.se.value,
            countries.nl.value, countries.gb.value, countries.ch.value],
        missingDocumentCheckbox: 'rp',
    },
    residencePermitBack: {
        value: 'residence_permit_back',
        label: 'Residence Permit (Back)',
        category: 'POI',
        subCategories: ['POI-F'],
        sideName: 'Back',
        doubleSided: true,
        groupName: 'residencePermit',
        localization: { id: '', defaultMessage: '' },
        applicableCountries: [countries.at.value, countries.bg.value, countries.hr.value, countries.cz.value, countries.dk.value, countries.ee.value,
            countries.fi.value, countries.fr.value, countries.de.value, countries.gr.value, countries.hu.value, countries.is.value, countries.ie.value,
            countries.it.value, countries.lv.value, countries.li.value, countries.lt.value, countries.lu.value, countries.mt.value, countries.no.value,
            countries.pl.value, countries.pt.value, countries.ro.value, countries.sk.value, countries.si.value, countries.es.value, countries.se.value,
            countries.nl.value, countries.gb.value, countries.ch.value],
        missingDocumentCheckbox: 'rp',
    },
    affiliateContract: {
        value: 'affiliate_contract',
        label: 'Affiliate Contract',
        category: 'partner',
        subCategories: ['partner', 'affiliate'],
        localization: { id: '', defaultMessage: '' },
        dueCourse: true,
    },
    proofOfDeposit: {
        value: 'proofOfDeposit',
        label: 'Proof of deposit',
        category: 'POF',
        subCategories: ['POF-F'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.crypto.value,
        ],
    },
    privateWalletAddress: {
        value: 'privateWalletAddress',
        label: 'Private Wallet Address',
        category: 'POF',
        subCategories: ['POF-F'],
        localization: { id: '', defaultMessage: '' },
        fundingCategories: [
            fundingCategories.crypto.value,
        ],
    },
    certificateOfIncorporation: {
        value: 'doc_certificate_of_incorporation',
        label: 'Certificate of Incorporation',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
        corporateStep: 6,
    },
    certificateOfGoodStanding: {
        value: 'doc_certificate_of_good_standing',
        label: 'Certificate of Good Standing (Certificate of Incumbency)',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
        comment: documentComments.notOlder,
        corporateStep: 6,
        passedYearsCheck: 1,
        passedYearsCheckDateField: corporateFields.registrationDate,
        alternativeComment: documentAlternativeComments.passedOneYearCommentGSC,
    },
    certificateOfDirectors: {
        value: 'doc_certificateof_directors',
        label: 'Certificate of Directors and Secretary',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
        corporateStep: 6,
    },
    certificateOfOffice: {
        value: 'doc_certificate_of_office',
        label: 'Certificate of Registered Office',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
        corporateStep: 6,
    },
    certificateOfShareholders: {
        value: 'doc_certificate_of_shareholders',
        label: 'Certificate of Registered Shareholders',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
        corporateStep: 6,
    },
    memorandumArticlesOfAssociation: {
        value: 'doc_memorandum_and_articles_of_association',
        label: 'Memorandum & Articles of Association of the Company',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
        corporateStep: 6,
    },
    financialStatements: {
        value: 'doc_financial_statements',
        label: 'Financial statements',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
        comment: documentComments.lastStatements,
        corporateStep: 6,
        passedYearsCheck: 1,
        passedYearsCheckDateField: corporateFields.registrationDate,
        alternativeComment: documentAlternativeComments.passedOneYearCommentFS,
    },
    declarationBeneficialOwner: {
        value: 'doc_declaration_beneficial_owner',
        label: 'Declaration Beneficial Owner',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
        corporateStep: 7,
    },
    resolutionDirectors: {
        value: 'doc_resolution_directors',
        label: 'Resolution Directors',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
        corporateStep: 7,
    },
    otherCorporate: {
        value: 'doc_other_corporate',
        label: 'Other',
        category: 'corporate',
        localization: { id: '', defaultMessage: '' },
    },
    localDepositorAgreement: {
        value: 'local_depositor_agreement',
        label: 'LD Agreement',
        category: 'local_depositor',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const documentTranslationTypes = generateKeys({
    porTranslation: {
        value: 'porTranslation',
        label: 'POR Translation',
        documentTypes: [
            documentTypes.proofOfResidence.key,
            documentTypes.utilityBill.key,
            documentTypes.bankStatementPOR.key,
            documentTypes.bankStatementPOF.key,
            documentTypes.proofOfAddressTranslation.key,
            documentTypes.bankStatement.key,
            documentTypes.taxStatement.key,
            documentTypes.payslip.key,
            documentTypes.hukouPOR.key,
            documentTypes.hukouPORBack.key,
        ],
    },
    poiTranslation: {
        value: 'poiTranslation',
        label: 'POI Translation',
        documentTypes: [
            documentTypes.idFront.key,
            documentTypes.idBack.key,
            documentTypes.passport.key,
            documentTypes.drivingLicenseFront.key,
            documentTypes.drivingLicenseBack.key,
            documentTypes.idTranslation.key,
        ],
    },
    corporateTranslation: {
        value: 'corporateTranslation',
        label: 'Corporate Translation',
        documentTypes: [
            documentTypes.cardStatement.key,
            documentTypes.cardCopies.key,
            documentTypes.cardCopiesBack.key,
            documentTypes.certificateOfGoodStanding.key,
            documentTypes.certificateOfShareholders.key,
            documentTypes.certificateOfIncorporation.key,
            documentTypes.memorandumArticlesOfAssociation.key,
        ],
    },
    otherTranslation: {
        value: 'otherTranslation',
        label: 'Other Translation',
        documentTypes: [
            documentTypes.other.key,
            documentTypes.iBagreement.key,
            documentTypes.dueDiligence.key,
            documentTypes.proofOfSignature.key,
            documentTypes.approvalRejectionForm.key,
            documentTypes.specialPowerOfAttorney.key,
            documentTypes.revocationOfPoaSpoa.key,
            documentTypes.thirdPartyAuthorizationLetter.key,
            documentTypes.thirdPartyIdPassport.key,
            documentTypes.residencePermitVisa.key,
            documentTypes.address.key,
            documentTypes.limitedPowerOfAttorney.key,
            documentTypes.worldcheckResults.key,
            documentTypes.swiftCopyPaymentAdvice.key,
            documentTypes.virtualCard.key,
            documentTypes.bankCard.key,
            documentTypes.coinbasePop.key,
            documentTypes.jointAccountForm.key,
            documentTypes.bankPaymentDetails.key,
            documentTypes.companiesRegistryExtract.key,
            documentTypes.businessLicense.key,
            documentTypes.promotionalMaterial.key,
            documentTypes.professionalApplication.key,
            documentTypes.thirdPartyWc.key,
            documentTypes.privateWallet.key,
            documentTypes.btcEthPop.key,
            documentTypes.otherPOF.key,
            documentTypes.residencePermit.key,
            documentTypes.affiliateContract.key,
            documentTypes.privateWalletAddress.key,
            documentTypes.proofOfDeposit.key,
            documentTypes.residencePermitBack.key,
        ],
    },
});
export const documentTranslationFields = generateKeys({
    nameIssuingAuthority: {
        value: 'nameIssuingAuthority',
        label: 'Name of the issuing authority',
        allowedTypes: [
            documentTranslationTypes.porTranslation.value,
        ],
    },
    fullName: {
        value: 'fullName',
        label: 'Full Name',
        allowedTypes: [
            documentTranslationTypes.porTranslation.value,
            documentTranslationTypes.poiTranslation.value,
            documentTranslationTypes.otherTranslation.value,
        ],
    },
    address: {
        value: 'address',
        label: 'Address',
        allowedTypes: [
            documentTranslationTypes.poiTranslation.value,
            documentTranslationTypes.porTranslation.value,
            documentTranslationTypes.otherTranslation.value,
        ],
    },
    issueDate: {
        value: 'issueDate',
        label: 'Issue date',
        allowedTypes: [
            documentTranslationTypes.porTranslation.value,
            documentTranslationTypes.poiTranslation.value,
            documentTranslationTypes.otherTranslation.value,
        ],
    },
    dateOfBirth: {
        value: 'dateOfBirth',
        label: 'Date of birth',
        allowedTypes: [
            documentTranslationTypes.poiTranslation.value,
        ],
    },
    nationality: {
        value: 'nationality',
        label: 'Nationality',
        allowedTypes: [
            documentTranslationTypes.poiTranslation.value,
        ],
    },
    expiryDate: {
        value: 'expiryDate',
        label: 'Expiry date',
        allowedTypes: [
            documentTranslationTypes.poiTranslation.value,
            documentTranslationTypes.otherTranslation.value,
        ],
    },
    companyName: {
        value: 'companyName',
        label: 'Company name',
        allowedTypes: [
            documentTranslationTypes.corporateTranslation.value,
        ],
    },
    typeOfBusiness: {
        value: 'typeOfBusiness',
        label: 'Type of Business / Core business operations',
        allowedTypes: [
            documentTranslationTypes.corporateTranslation.value,
        ],
    },
    registerNumber: {
        value: 'registerNumber',
        label: 'Register Number',
        allowedTypes: [
            documentTranslationTypes.corporateTranslation.value,
        ],
    },
    dayOfIncorporation: {
        value: 'dayOfIncorporation',
        label: 'Day of incorporation',
        allowedTypes: [
            documentTranslationTypes.corporateTranslation.value,
        ],
    },
    registeredAddress: {
        value: 'registeredAddress',
        label: 'Registered Address',
        allowedTypes: [
            documentTranslationTypes.corporateTranslation.value,
        ],
    },
    directorsDetails: {
        value: 'directorsDetails',
        label: 'Directors details (Full name, Position, Number of shares)',
        allowedTypes: [
            documentTranslationTypes.corporateTranslation.value,
        ],
    },
    totalShares: {
        value: 'totalShares',
        label: 'Total Shares',
        allowedTypes: [
            documentTranslationTypes.corporateTranslation.value,
        ],
    },
    shareholdersDetails: {
        value: 'shareholdersDetails',
        label: 'Shareholders details (Full name, Position, Number of shares)',
        allowedTypes: [
            documentTranslationTypes.corporateTranslation.value,
        ],
    },
    other: {
        value: 'other',
        label: 'Other',
        allowedTypes: [
            documentTranslationTypes.porTranslation.value,
            documentTranslationTypes.poiTranslation.value,
            documentTranslationTypes.corporateTranslation.value,
            documentTranslationTypes.otherTranslation.value,
        ],
    },
});
export const proofOfResidencyDocumentTypes = pickBy(documentTypes, (type) => type.category === 'POR');
export const proofOfIdentityDocumentTypes = pickBy(documentTypes, (type) => type.category === 'POI');
export const proofOfFundsDocumentTypes = pickBy(documentTypes, (type) => type.category === 'POF');
export const internalDocumentTypes = pickBy(documentTypes, (type) => type.category === 'internal');
export const partnerDocumentTypes = pickBy(documentTypes, (type) => type.category === 'partner');
export const personalDocsDocumentTypes = pickBy(documentTypes, (type) => type.category === 'personal');
export const coporateDocsDocumentTypes = pickBy(documentTypes, (type) => type.category === 'corporate');
export const localDepositorDocumentTypes = pickBy(documentTypes, (type) => type.category === 'local_depositor');
export const processDocumentResults = generateKeys({
    approve: {
        value: 'approve',
        label: 'Accept',
    },
    reject: {
        value: 'reject',
        label: 'Reject',
    },
});
